export default __webpack_public_path__ + "static/media/tizen-brasil.4e89c7c3.png";